import {BadgeType, ItemType} from '../graphql/generated/types';
import {AgeGradeVo} from './shared/api/gateway/enums/AgeGradeVo.enum';
import {BadgeTypeVo} from './shared/api/gateway/enums/BadgeTypeVo.enum';
import {BusinessModelVo} from './shared/api/nicolas/vo/enums/BusinessModelVo.enum';
import {LastViewDto} from './shared/api/nicolas/vo/LastViewDto.interface';

/**
 * NEXT 에서 일반적으로 사용되는 뱃지 오브젝트를 리턴하는 함수
 * 대부분의 케이스(빅배너, 카드뷰, 포스터뷰 등등 일반적인 뷰 아이템)에서 이 함수를 통해 뱃지 오브젝트를 가져옴
 */
export function getCommonBadge(
  param:
    | {
        itemType: ItemType.Banner | ItemType.EventBanner;
        is_waitfree: boolean;
        waitfree_period_by_minute: number | null;
        business_model?: BusinessModelVo;
        badge?: BadgeTypeVo;
      }
    | {
        itemType:
          | ItemType.PosterView
          | ItemType.CardView
          | ItemType.CleanView
          | ItemType.RankingListView
          | ItemType.RankingCardView
          | ItemType.RankingPosterView
          | ItemType.NormalListView;
        is_waitfree: boolean;
        waitfree_period_by_minute: number | null;
        business_model?: BusinessModelVo;
        badge?: BadgeTypeVo;
        age_grade: AgeGradeVo;
        self_censorship?: boolean;
      }
    | {
        itemType: ItemType.SingleListView;
        is_free?: boolean;
        hidden?: boolean;
        badge?: BadgeTypeVo;
        last_view?: LastViewDto;
        purchased?: boolean;
      }
): {
  badgeList: BadgeType[];
  statusBadge?: BadgeType;
  ageGradeBadge?: BadgeType;
} {
  const {itemType} = param;
  if (itemType === ItemType.SingleListView) {
    const {is_free, hidden, badge, last_view, purchased} = param;
    const showLockBadge = !is_free && hidden;

    return {
      badgeList: [
        ...(showLockBadge
          ? purchased
            ? [BadgeType.BadgeUnlock]
            : [BadgeType.BadgeLock]
          : []),
        // 서버에서 등록된 후 1일동안 up 뱃지를 내려줌. 만약 열람 이력이 없고 Lock 되지 않았다면 뱃지를 보여줌
        ...(badge === BadgeTypeVo.Up && !showLockBadge && !last_view
          ? [BadgeType.BadgeUpStatic]
          : []),
      ],
    };
  }
  const {is_waitfree, waitfree_period_by_minute, business_model, badge} = param;
  let bmBadge;
  // 무료 > 삼다무 > 기다무
  if (
    business_model === BusinessModelVo.Web ||
    business_model === BusinessModelVo.Mix
  ) {
    bmBadge = BadgeType.BadgeRealFreeStatic; // 무료
  } else if (is_waitfree) {
    bmBadge = getWaitfreeBadge(waitfree_period_by_minute);
  }

  let statusBadge; // 기획에선 업데이트 뱃지, 개발(App)에선 status 뱃지라 부름
  if (itemType === ItemType.EventBanner) {
    statusBadge = BadgeType.BadgeEventStatic;
  } else if (badge === BadgeTypeVo.Up) {
    statusBadge = BadgeType.BadgeUpStatic;
  } else if (badge === BadgeTypeVo.New) {
    statusBadge = BadgeType.BadgeNewStatic;
  }

  let ageGradeBadge;
  if ('age_grade' in param && param.age_grade !== undefined) {
    const {age_grade} = param;
    if (age_grade === AgeGradeVo.Fifteen) {
      ageGradeBadge = BadgeType.BadgeAge15Static;
    } else if (age_grade === AgeGradeVo.Nineteen) {
      if ('self_censorship' in param && param.self_censorship) {
        ageGradeBadge = BadgeType.BadgeAge19CensorshipStatic;
      } else {
        ageGradeBadge = BadgeType.BadgeAge19Static;
      }
    }
  }
  return {
    badgeList: [...(bmBadge ? [bmBadge] : [])],
    statusBadge,
    ageGradeBadge,
  };
}

export function getWaitfreeBadge(waitfreePeriodByMinute?: number | null) {
  if (!waitfreePeriodByMinute || waitfreePeriodByMinute > 180) {
    return BadgeType.BadgeWaitFreeStatic;
  }

  const hourPeriod = Math.floor(waitfreePeriodByMinute / 60);
  // KW-8960 사업 요청으로 1다무 뱃지는 기다무 뱃지로 변경(프로모션 진행하려는데 CP사에서 '다무' 문구를 싫어한다고 대체하는거라 임시 변경일 가능성이 있음)
  if (hourPeriod === 1) {
    return BadgeType.BadgeWaitFreeStatic;
  }
  return WAITFREE_BADGE_LIST[hourPeriod];
}

const WAITFREE_BADGE_LIST = [
  BadgeType.Badge0HourWaitfreeStatic,
  BadgeType.Badge1HourWaitfreeStatic,
  BadgeType.Badge2HourWaitfreeStatic,
  BadgeType.Badge3HourWaitfreeStatic,
];
